import React, {  ReactNode, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "../Icons/LoadingSpinner";

const HotListUser = React.lazy(() => import("../pages/Dashboard/hot-list/hot-list-profile"));
const HotListCreate = React.lazy(() => import("../pages/Dashboard/hot-list/new"));



const TimeSheet = React.lazy(() => import("../components/ProjectTracker/TimeSheet"));
const AddNewCustomer = React.lazy(() => import("../section/customers/add-new-customer/view"));

const CalendarC = React.lazy(() => import("../components/Organization/Employee/AddExist/calendar/Calendar"));

// Projects
const ProjectDashboard = React.lazy(() => import("../pages/Dashboard/Projects/Dashboard/ProjectDashboard"));
const EditProject = React.lazy(() => import("../pages/Dashboard/Projects/projects/edit"));
const AddNewProject = React.lazy(() => import('../pages/Dashboard/Projects/projects/add'));

// Hot lIst
const CandidateHotList = React.lazy(() => import('../pages/Dashboard/jobs/hot-list/list'));
const CreateCandidateHotList = React.lazy(() => import('../pages/Dashboard/jobs/hot-list/new'));

const HotListCandidate = React.lazy(() => import("../pages/candidate-hot-list/profile"));

const ProtectedAdminRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
  const isAdmin = localStorage.getItem('roleName');
  return isAdmin === "Admin" ? (
    <> {children} </>
  ) : (
    <Navigate to="/dashboard" />
  );
};

const renderProtectedAdminRoute = (Component: React.ComponentType) => (
  <Suspense fallback={<LoadingSpinner className="mr-2 h-full w-14 animate-spin" />}>
    <ProtectedAdminRoute>
      <Component />
    </ProtectedAdminRoute>
  </Suspense>
);

export const AdminRoutes = [
  {
    path: "/dashboard/hot-list-candiate/profile/:id",
    element: renderProtectedAdminRoute(HotListCandidate),
    title: "Candidate Lists",
    role: ['admin'],
  },
  {
    path: "/dashboard/candidate-hot-list",
    element: renderProtectedAdminRoute(CandidateHotList),
    title: "Candidate Lists",
    role: ['admin'],
  },
  {
    path: "/dashboard/candidate-hot-list/add",
    element: renderProtectedAdminRoute(CreateCandidateHotList),
    title: "Candidate Lists",
    role: ['admin'],
  },
  {
    path: "/dashboard/jobs/candidate-hot-list/add",
    element: renderProtectedAdminRoute(CandidateHotList),
    title: "Candidate Lists",
    role: ['admin'],
  },
  {
    path: "/dashboard/projects-dashboard",
    element: renderProtectedAdminRoute(ProjectDashboard),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/hotlist-user/:id",
    element: renderProtectedAdminRoute(HotListUser),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/hotlist/create",
    element: renderProtectedAdminRoute(HotListCreate),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/projects/timesheet",
    element: renderProtectedAdminRoute(TimeSheet),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/projects/add-project",
    element: renderProtectedAdminRoute(AddNewProject),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/projects/edit-project/:projectId",
    element: renderProtectedAdminRoute(EditProject),
    title: "Dashboard",
    role: ['admin'],
  },
  {
    path: "/dashboard/leaves/calendar",
    element: renderProtectedAdminRoute(CalendarC),
    title: "Calendar",
    role: ['admin'],
  },
  {
    path: "/dashboard/customers/add-new",
    element: renderProtectedAdminRoute(AddNewCustomer),
    title: "Calendar",
    role: ['admin'],
  },
];